// Encryption and Decryption Utility for Live Video Links and Stream URLs

const STREAM_SECRET = 'vedika_live_secret_key_2026_x89!';

/**
 * Encrypts a stream key or video URL into an encrypted token.
 * @param {string} streamKey 
 * @returns {string} Encrypted token string
 */
export const encryptStreamToken = (streamKey) => {
  if (!streamKey) return '';
  try {
    const payload = JSON.stringify({ k: String(streamKey), t: Date.now() });
    let encrypted = '';
    for (let i = 0; i < payload.length; i++) {
      const charCode = payload.charCodeAt(i) ^ STREAM_SECRET.charCodeAt(i % STREAM_SECRET.length);
      encrypted += String.fromCharCode(charCode);
    }
    const base64 = typeof btoa === 'function'
      ? btoa(encrypted)
      : Buffer.from(encrypted, 'binary').toString('base64');
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch (err) {
    console.error('Failed to encrypt stream token:', err);
    return streamKey;
  }
};

/**
 * Decrypts an encrypted stream token back into the stream key.
 * @param {string} token 
 * @returns {string|null} Stream key or null if invalid
 */
export const decryptStreamToken = (token) => {
  if (!token) return null;
  try {
    let base64 = token.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    const binary = typeof atob === 'function'
      ? atob(base64)
      : Buffer.from(base64, 'base64').toString('binary');
    let decrypted = '';
    for (let i = 0; i < binary.length; i++) {
      const charCode = binary.charCodeAt(i) ^ STREAM_SECRET.charCodeAt(i % STREAM_SECRET.length);
      decrypted += String.fromCharCode(charCode);
    }
    const data = JSON.parse(decrypted);
    return data && data.k ? data.k : null;
  } catch (err) {
    return null;
  }
};

/**
 * Generates an encrypted live stream FLV video URL.
 * @param {string} streamKey 
 * @param {string} serverUrl 
 * @returns {string} Encrypted video link
 */
export const getEncryptedLiveStreamUrl = (streamKey, serverUrl = '') => {
  if (!streamKey) return '';
  const token = encryptStreamToken(streamKey);
  const baseUrl = serverUrl ? serverUrl.replace(/\/$/, '') : '';
  return `${baseUrl}/live/stream/${token}.flv`;
};

/**
 * Masks a sensitive string like stream key or RTMP URL for secure UI display.
 * @param {string} str 
 * @returns {string} Masked string
 */
export const maskSecretString = (str) => {
  if (!str) return '';
  if (str.length <= 8) return '********';
  return str.slice(0, 4) + '••••••••' + str.slice(-4);
};
